<re-captcha
  (errored)="handleReCaptchaFailure()"
  (resolved)="handleReCaptchaResolved($event)"
  [siteKey]="reCaptchaSiteKey()" />
